const InvestmentReview = () => {
	return <div>InvestmentReview</div>;
};

export default InvestmentReview;
